export default __webpack_public_path__ + "static/media/g18.be06f834.png";